
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import RegisterQR from "./Pages/RegisterQR";
import Dashboard from "./Pages/Dashboard";
import QRCodes from "./Pages/QRCodes";
import Users from "./Pages/Users";
import Analytics from "./Pages/Analytics";
import Settings from "./Pages/Settings";
import Create from "./Pages/Create";
import Home from "./Pages/Home";
import EditRegistration from "./Pages/EditRegistration.jsx"; 
import RequestForm from "./Pages/RequestForm.jsx";  
import AdminLogin from "./Pages/Adminlogin.jsx";
import Requests from "./Pages/Requests.jsx";
import PrivacyPolicy from "./Pages/privacypolicy.jsx";
import TermsOfUse from "./Pages/terms.jsx";
// updated code

function App() {
  return (
    <Router>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} /> 
        <Route path="/register/:qrId" element={<RegisterQR />} /> 
        <Route path="/:qrId" element={<RegisterQR />} />
        <Route path="/registrations/:qrId" element={<EditRegistration />} />
        <Route path="/requestform" element={<RequestForm />} />
        <Route path ="/access" element={<AdminLogin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/qrcodes" element={<QRCodes />} />
        <Route path="/users" element={<Users />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/create" element={<Create />} />
        <Route path="/requests" element={<Requests />} />

      </Routes>
    </Router>
  );
}

export default App;

